import React from "react";
import { VerticalTabWorkList } from "../../secondary/VerticalTabWorkList";
import { useWorkListTabs } from "./hooks/useWorkListTabs";
import { WorklistScreen } from "./worklistScreen";
import { WORKLIST_CONFIG } from "./worklistConfig";

export function PIAssessment({ facilityNumber }) {
  const { dispatch, defaultVerTab, onSelectVerTab, poaCount, nonpoaCount } = useWorkListTabs(facilityNumber, "piAssessmentsValues");

  const tabList = [
    {
      name: `POA ${poaCount}`,
      key: "poa",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.piAssessmentsPOA} />,
      bottomName: "Pending Review",
    },
    {
      name: `Non-POA ${nonpoaCount}`,
      key: "nonPoa",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.piAssessmentsNONPOA} />,
      bottomName: "Pending Review",
    },
  ];

  return (
    <VerticalTabWorkList onSelectInt={onSelectVerTab} defaultIndex={defaultVerTab <= 1 ? defaultVerTab : 0} tabList={tabList} dispatch={dispatch} />
  );
}
